<div class="stli__wrapper" *ngIf="statisticsListItem"
     [class.lost]="statisticsListItem.multiplier?.data && !statisticsListItem.totalAmount?.data"
     [class.won]="!!statisticsListItem.totalAmount?.data">
    <ng-container *ngFor="let item of objectKeys(statisticsListItem)">
        <div class="stli__container--user" *ngIf="item === 'user'"
             [ngStyle]="extractStyleFromObject(item, statisticsListItem)">
            <avatar class="stli__avatar"
                    [avatarUrl]="extractDataFromObject(item, statisticsListItem)?.avatarUrl"></avatar>
            <p>{{extractDataFromObject(item, statisticsListItem)?.name}}</p>
        </div>
        <div class="stli__container--date" *ngIf="item === 'date'"
             [ngStyle]="extractStyleFromObject(item, statisticsListItem)">
            <span
                *ngIf="extractDataFromObject(item, statisticsListItem); else emptyText">
                {{extractDataFromObject(item, statisticsListItem) * 1000 | date:'dd.MM.y HH:mm'}}</span>
        </div>
        <div class="stli__container--bet {{item}}" *ngIf="item === 'bet' || item === 'totalAmount'"
             [ngStyle]="extractStyleFromObject(item, statisticsListItem)">
            <span
                *ngIf="extractDataFromObject(item, statisticsListItem); else emptyText">{{extractDataFromObject(item, statisticsListItem) | balance:true:true }}</span>
        </div>
        <div class="stli__container--payout-item" *ngIf="item === 'multiplier'"
             [ngStyle]="extractStyleFromObject(item, statisticsListItem)">
            <payout-item *ngIf="extractDataFromObject(item, statisticsListItem); else emptyText"
                         class="stli__payout-item"
                         [coefficient]="extractDataFromObject(item, statisticsListItem)" [split]="extractDataFromObject('split', statisticsListItem)"></payout-item>
        </div>
    </ng-container>
</div>
<ng-template #emptyText>
    <span class="stli__text--empty"></span>
</ng-template>
